import { useEffect } from 'react'
import { type LarryToHostMessage, larryActivityMessage } from '@/lib/embed/host-messages'

const ACTIVITY_EVENTS = ['pointerdown', 'pointermove', 'keydown', 'wheel'] as const

/**
 * Tells the host the user is working in Larry, at most once per `throttleMs`. The host can't see
 * input inside a cross-origin iframe, so without this its keepalive goes idle and the shared
 * yb360 session (which Larry's JWT can't outlive) expires mid-edit.
 */
export function useHostActivityReporter(
  postToHost: (message: LarryToHostMessage) => void,
  throttleMs: number
): void {
  useEffect(() => {
    let lastReportedAt = Number.NEGATIVE_INFINITY

    const report = () => {
      const now = Date.now()

      if (now - lastReportedAt < throttleMs) return

      lastReportedAt = now
      postToHost(larryActivityMessage())
    }

    for (const type of ACTIVITY_EVENTS) {
      window.addEventListener(type, report, { capture: true, passive: true })
    }

    return () => {
      for (const type of ACTIVITY_EVENTS) {
        window.removeEventListener(type, report, { capture: true })
      }
    }
  }, [postToHost, throttleMs])
}
